import React from "react"
import { Flex, Text } from "@chakra-ui/react"
import URL from "components/elements/Link"
import { FormType } from "sharedTypes"
import CopyToClipboard from "components/elements/CopyToClipboard"

type Props = {
  type: FormType
  url?: string
}

const Link = ({ type, url }: Props) => {
  if (!url) {
    return null
  }

  const isRSVPOrSurvey = [FormType.RSVP, FormType.Survey].includes(type)

  return (
    <Flex flexDirection="column" justifyContent="flex-end">
      <Flex align="center" gap={2}>
        <URL isExternal href={url}><Text lineHeight={3}>{url}</Text></URL>
        <CopyToClipboard text={url} size="xs" variant="outline">Copy</CopyToClipboard>
      </Flex>
      {isRSVPOrSurvey && <Text position="relative" bottom={-3} fontSize="xs" color="gray.600" lineHeight={0}>Actual form link will be generated uniquely for each guest.</Text>}
    </Flex>
  )
}

export default Link
